import { closingAttorneyContactCard, insertIntoArray } from '../../shared';
import type { OfferLocaleOverrides } from '../base';

export const GAOverrides: OfferLocaleOverrides = {
  locale: 'GA',
  sections: {
    propertyInfo: {
      cards: {
        propertyBeingSoldCard: {
          layout: (layout) =>
            layout.concat([
              [
                {
                  name: 'property.taxIdNumber',
                  size: 100,
                },
              ],
              [
                {
                  name: 'property.platbook',
                  size: 50,
                },
                {
                  name: 'property.pages',
                  size: 50,
                },
              ],
            ]),
          fields: {
            mlsAutofill: {
              action: {
                props: (props) =>
                  props.filter(
                    ({ from }) => from !== 'property.legalDescription',
                  ),
              },
            },
            taxIdNumber: {
              name: 'property.taxIdNumber',
              entity: 'property',
              type: 'text',
              label: 'Property Tax ID Number',
              placeholderText: '',
            },
            platbook: {
              name: 'property.platbook',
              entity: 'property',
              type: 'text',
              label: 'Deed Book',
              placeholderText: '',
            },
            pages: {
              name: 'property.pages',
              entity: 'property',
              type: 'text',
              label: 'Page',
              placeholderText: '',
            },
          },
        },
        importantDatesCard: {
          // Replaces the base layout outright — a field added to the base card
          // has to be repeated here or it never renders in GA
          layout: () => [
            [
              {
                name: 'contractDate',
                size: 33,
              },
              {
                name: 'closingDate',
                size: 33,
              },
              {
                name: 'bindingAgreementDate',
                size: 33,
              },
            ],
            [{ name: 'acceptanceDate', size: 50 }],
          ],
          fields: {
            contractDate: {
              label: 'Offer Date',
              validation: [
                {
                  type: 'required',
                  message: 'Required',
                },
              ],
            },
            closingDate: {
              validation: [
                {
                  type: 'required',
                  message: 'Required',
                },
              ],
            },
            bindingAgreementDate: {
              name: 'bindingAgreementDate',
              entity: 'interaction',
              type: 'date',
              label: 'Binding Agreement Date',
              placeholderText: '',
            },
          },
        },
      },
    },
    buySideContacts: {
      cards: {
        buyersAgentCard: {
          layout: (layout) =>
            insertIntoArray(layout, 5, [
              {
                name: 'contacts.agent.x.brokerage.mlsCode',
                size: 100,
              },
            ]),
          fields: {
            brokerageMlsCode: {
              type: 'text',
              placeholderText: '',
              disabledForIndex: 0,
            },
            submitAs: {
              action: {
                props: (props) =>
                  props.filter(({ from }) => from !== 'brokerageMlsCode'),
              },
            },
          },
        },
      },
    },
    sellerSideContacts: {
      cards: {
        sellersAgentCard: {
          layout: (layout) =>
            insertIntoArray(layout, 5, [
              {
                name: 'contacts.counterpartyAgent.x.brokerage.mlsCode',
                size: 100,
              },
            ]),
          fields: {
            firstName: {
              action: {
                props: (props) =>
                  props.concat([
                    {
                      from: 'brokerage.mlsCode',
                      to: 'contacts.counterpartyAgent.x.brokerage.mlsCode',
                    },
                  ]),
              },
            },
            brokerageMlsCode: {
              name: 'contacts.counterpartyAgent.x.brokerage.mlsCode',
              entity: 'contacts',
              entityType: 'counterpartyAgent',
              type: 'text',
              label: 'Brokerage MLS Code',
              placeholderText: '',
            },
          },
        },
        sellerCard: {
          fields: {
            firstName: {
              validation: () => [],
            },
          },
        },
      },
    },
    additionalContacts: {
      cards: {
        titleOfficerContactCard: null,
        attorneyContactCard: () => closingAttorneyContactCard,
        addAdditionalContactCard: {
          fields: {
            newContact: {
              options: (options) => [
                {
                  label: 'Closing Attorney',
                  value: 'additionalContacts.closingAttorney',
                },
                ...options.slice(1),
              ],
            },
          },
        },
      },
    },
  },
};
